// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page__ShopifyIntegration.BC-Page.BC-Page__ShopifyIntegration__Manage .BC-Page__Title--Help {
  padding-left: 2px;
}

.BC-Page__ShopifyIntegration .main-layout .Polaris-Card__Header {
  background-color: #fff;
  border: 0;
  padding-bottom: 0;
}

.BC-Page__ShopifyIntegration .main-layout .cardTitle {
  align-items: center;
  justify-content: space-between;
}

.BC-Page__ShopifyIntegration .main-layout .cardTitle .Polaris-Button__Icon {
  width: 20px;
  height: 20px;
}

.BC-Page__ShopifyIntegration .main-layout .empty-block {
  border: 1px solid #e1e3e5;
  background-color: #fafbfb;
  padding: 24px 0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.BC-Page__ShopifyIntegration .main-layout .manage-template-block .template-item {
  display: flex;
  border: 1px solid #e1e3e5;
  border-radius: 4px;
}

.BC-Page__ShopifyIntegration .main-layout .manage-template-block .template-item__info {
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 6px;
  padding: 16px;
}

.BC-Page__ShopifyIntegration .main-layout .helper-block {
  padding: 12px 16px;
  background-color: #fff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.BC-Page__ShopifyIntegration .main-layout .helper-block .Polaris-Button {
  padding: 12px 26px;
}

.BC-Page__ShopifyIntegration .main-layout .helper-block .Polaris-Button {
  background-color: #fafbfb;
}

.BC-Page__ShopifyIntegration .main-layout .helper-block .Polaris-Button:hover {
  background-color: #f6f6f7;
}

.BC-Page__ShopifyIntegration .main-layout .helper-block .Polaris-Button__Text {
  display: flex;
  align-items: center;
  gap: 2px;
}

.BC-Page__ShopifyIntegration .main-layout .helper-block .Polaris-Button__Text .Polaris-Icon {
  margin: 0;
  width: 16px;
  height: 16px;
}

.BC-Page__ShopifyIntegration
  .main-layout
  .helper-block
  .Polaris-Button
  .Polaris-Button__Content
  > .Polaris-Button__Icon {
  width: 14px;
  height: 14px;
}

.BC-Page__ShopifyIntegration .main-layout .BC-Page__ShopifyIntegration__Pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.BC-Page__ShopifyIntegration
  .main-layout
  .BC-Page__ShopifyIntegration__Pagination
  .Polaris-ButtonGroup__Item {
  margin-left: 12px;
}

.BC-Page__ShopifyIntegration
  .main-layout
  .BC-Page__ShopifyIntegration__Pagination
  .Polaris-ButtonGroup__Item:first-child
  .Polaris-Button {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.BC-Page__ShopifyIntegration
  .main-layout
  .BC-Page__ShopifyIntegration__Pagination
  .Polaris-ButtonGroup__Item:last-child
  .Polaris-Button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.BC-Page__ShopifyIntegration .main-layout .Polaris-DataTable {
  border: 1px solid rgba(225, 227, 229, 1);
  border-radius: 8px;
}

.BC-Page__ShopifyIntegration .main-layout .Polaris-DataTable__Table thead .Polaris-DataTable__Cell {
  padding: 12px 16px;
  font-weight: 600;
}

.BC-Page__ShopifyIntegration
  .main-layout
  .Polaris-DataTable__Table
  thead
  .Polaris-DataTable__Cell:nth-child(2) {
  width: 200px;
}

.BC-Page__ShopifyIntegration
  .main-layout
  .Polaris-DataTable__Table
  thead
  .Polaris-DataTable__Cell:last-child {
  width: 113px;
  text-align: center;
}

.BC-Page__ShopifyIntegration
  .main-layout
  .Polaris-DataTable__Table
  tbody
  .Polaris-DataTable__Cell:last-child
  .data-cell-inner {
  justify-content: center;
}

.BC-Page__ShopifyIntegration .main-layout .Polaris-DataTable__Table tbody .Polaris-DataTable__Cell {
  padding: 0;
}

.BC-Page__ShopifyIntegration
  .main-layout
  .Polaris-DataTable__Table
  tbody
  .Polaris-DataTable__Cell
  .data-cell-inner {
  padding: 12px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.BC-Page__ShopifyIntegration
  .main-layout
  .Polaris-DataTable__Table
  tbody
  .Polaris-DataTable__Cell
  .data-cell-inner.data-cell-inner--default {
  cursor: default;
}

.BC-Page__ShopifyIntegration
  .main-layout
  .Polaris-DataTable__Table
  tbody
  .Polaris-DataTable__Cell:last-child
  .Polaris-Button {
  min-height: 30px;
  min-width: 81px;
  padding: 5px 8px;
}

.BC-Page__ShopifyIntegration
  .main-layout
  .Polaris-DataTable__Table
  tbody
  .Polaris-DataTable__Cell:last-child
  .Polaris-Button
  .Polaris-Button__Icon {
  width: 16px;
  height: 16px;
}

.BC-Page__ShopifyIntegration
  .main-layout
  .Polaris-DataTable__Table
  tbody
  .Polaris-DataTable__Cell
  .Polaris-SkeletonDisplayText__DisplayText {
  width: 100%;
  max-width: 100%;
}

.BC-Page__ShopifyIntegration .main-layout .select-theme-refresh {
  height: 20px;
  transition: all 0.4s;
}

.BC-Page__ShopifyIntegration .main-layout .select-theme-refresh.refreshing {
  -webkit-animation: spin 2s linear infinite;
  -moz-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

.btn-actions-warning .Polaris-ButtonGroup {
  justify-content: flex-end;
}

.btn-actions-warning .btn-remove .Polaris-Button {
  background-color: #bb8802;
  border: 0;
  color: #fff;
}

.btn-actions-warning .btn-remove .Polaris-Button:hover {
  background-color: #8f6901;
}

.BC-Page__ShopifyIntegration .BC-Page__Title--Help {
  margin-bottom: 24px;
}

.BC-Page__ShopifyIntegration .Polaris-Card__Header {
  border-top-left-radius: var(--p-border-radius-2);
  border-top-right-radius: var(--p-border-radius-2);
  background-color: #fafbfb;
}

.BC-Page__ShopifyIntegration .select-theme {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.BC-Page__ShopifyIntegration .select-theme > div {
  width: inherit;
}

/* Calculate filter: https://codepen.io/sosuke/pen/Pjoqqp */
.BC-Page__ShopifyIntegration .BC-Shopify-Integration_Select-Theme-Form .select-theme-refresh {
  height: 20px;
  margin-left: 10px;
  filter: invert(42%) sepia(13%) saturate(4337%) hue-rotate(184deg) brightness(90%) contrast(95%);
}

.BC-Page__ShopifyIntegration
  .BC-Shopify-Integration_Select-Theme-Form
  .select-theme-refresh.refreshing {
  animation: rotation 2s linear infinite;
}

.BC-Page__ShopifyIntegration .BC-Shopify-Integration_Select-Theme-Form button {
  margin-top: 16px;
}

.BC-Page__ShopifyIntegration .BC-Shopify-Integration_Select-Theme-Form .btnNext {
  text-align: right;
}

#ssr-selected-theme-item {
  margin-left: 5px;
}

#ssr-selected-theme-item.live .Polaris-Badge {
  background-color: #e0f0ff;
  color: #00527c;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
}

.BC-Page__ShopifyIntegration .warning-none-features {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #EC4A0A;
  background-color: #FFF6ED;
  padding: 2px 6px;
  margin-top: 4px;
  border-radius: 4px;
}

.BC-Page__ShopifyIntegration .warning-none-features .Polaris-Icon {
  width: 14px;
  height: 14px;
  position: relative;
  top: 1px;
}

.BC-Page__ShopifyIntegration .warning-none-features .Polaris-Icon__Svg {
  fill: #EC4A0A;
}

.upgraded-to-turbo .Polaris-Badge {
  background-color: #ebf9fc;
  color: #2c6ecb;
  border-radius: 10px;
}

.BC-Select-Integration__option:has(.unpublished) .unpublished {
  display: none;
}

.BC-Page__ShopifyIntegration .theme-setup-heading .Polaris-Badge {
  margin-left: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  font-size: 12px;
  background-color: #c9cccf;
  border-radius: 10px;
}

.BC-Page__ShopifyIntegration .theme-setup-heading .Polaris-SkeletonDisplayText__DisplayText {
  width: 100%;
  max-width: 100%;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .Polaris-Layout
  .Polaris-SkeletonDisplayText__DisplayText {
  width: 100%;
  max-width: 100%;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .Polaris-Layout
  .onboarding-loading
  .Polaris-SkeletonDisplayText__DisplayText {
  width: 20%;
  max-width: 20%;
  display: inline-flex;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .Polaris-Layout
  .loading-content
  .Polaris-SkeletonDisplayText__DisplayText {
  height: 244px;
}

.BC-Page__ShopifyIntegration .theme-setup-heading .Polaris-Badge--statusInfo {
  background-color: #e0f0ff;
  color: #00527c;
  font-weight: 500;
}

.BC-Page__ShopifyIntegration .integration-layout {
  margin-top: 24px;
}

/* Progress bar */
.BC-Page__ShopifyIntegration .integration-layout .progress-bar {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.BC-Page__ShopifyIntegration .integration-layout .progress-bar .step-content {
  display: inline-flex;
  color: #6d7175;
}

.BC-Page__ShopifyIntegration .integration-layout .progress-bar .number {
  width: 32px;
  height: 32px;
  border: solid 1px #e1e3e5;
  border-radius: 50%;
  padding-top: 4px;
  padding-left: 11px;
  font-weight: 700;
}

.BC-Page__ShopifyIntegration .integration-layout .progress-bar .Polaris-Icon {
  margin: 0;
}

.BC-Page__ShopifyIntegration .integration-layout .progress-bar .Polaris-Icon .Polaris-Icon__Svg {
  fill: #fff;
}

.BC-Page__ShopifyIntegration .integration-layout .progress-bar .label {
  padding: 6px 0 0 8px;
  font-weight: 600;
  line-height: 20px;
}

.BC-Page__ShopifyIntegration .integration-layout .progress-bar .active,
.BC-Page__ShopifyIntegration .integration-layout .progress-bar .activating {
  color: #202223;
}

.BC-Page__ShopifyIntegration .integration-layout .progress-bar .active > div.number {
  border-color: #008060;
  background-color: #008060;
  color: #fff;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.BC-Page__ShopifyIntegration .integration-layout .progress-bar .activating > div.number {
  border-color: #008060;
  color: #008060;
}

.BC-Page__ShopifyIntegration .integration-layout .progress-bar .separator.active {
  filter: invert(60%) sepia(19%) saturate(2378%) hue-rotate(120deg) brightness(96%) contrast(101%);
}

.BC-Page__ShopifyIntegration .integration-layout .progress-bar .separator {
  margin: 0 16px 0 16px;
}

/* Empty content */
.BC-Page__ShopifyIntegration .integration-layout .empty-content {
  background-color: #fafbfb;
  border-radius: 8px;
  border: 1px solid #e1e3e5;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .empty-content
  .Polaris-EmptyState--withinContentContainer {
  padding-bottom: var(--p-space-5);
}

.BC-Page__ShopifyIntegration .integration-layout .empty-content img {
  width: 48px;
  height: 48px;
}

.BC-Page__ShopifyIntegration .integration-layout .empty-content .Polaris-DisplayText {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  margin-top: 10px;
}

.BC-Page__ShopifyIntegration .integration-layout .empty-content .Polaris-EmptyState__Content {
  font-size: 14px;
  margin-top: 5px;
  padding-bottom: 0;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .copy
  .Polaris-Button--plain.Polaris-Button--iconOnly
  svg {
  fill: var(--p-icon-subdued);
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .copy
  .Polaris-Button--plain.Polaris-Button--iconOnly:hover
  svg {
  fill: var(--p-icon-hovered);
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .copy
  button.Polaris-Button--plain.Polaris-Button--iconOnly {
  margin: 3px 0 0 2px;
  padding: 0;
  min-width: auto;
  min-height: auto;
}

.BC-Page__ShopifyIntegration .integration-layout .copy .Polaris-Icon {
  width: 12px;
  height: 12px;
}

/* Select template modal */
.select-template-modal .Polaris-Modal-Section {
  padding: 0;
}

.select-template-modal .modal-content ul {
  list-style-type: none;
}

.select-template-modal .Polaris-Card__Section {
  padding-top: 20px;
  padding-bottom: 18px;
}

.select-template-modal .total-instance, .select-design-template-modal .total-instance {
  padding: 2px 6px;
  border: 1px solid #e4e5e7;
  border-radius: 50%;
  background-color: #e4e5e7;
  margin-right: 4px;
}

.select-template-modal .Polaris-Tabs__Wrapper .Polaris-Tabs {
  width: 40%;
}

.select-template-modal
  .Polaris-Tabs__Wrapper
  .Polaris-Tabs
  .Polaris-Tabs__TabContainer:not(:last-child) {
  width: 49%;
}

.select-template-modal.select-template-modal--limit .Polaris-Banner {
  margin: 24px 20px 10px;
}

.select-template-modal.select-template-modal--limit .Polaris-Banner__Ribbon {
  display: none;
}

.select-template-modal.select-template-modal--limit .select-template-modal--limit__guide {
  margin: 0 20px 10px;
}

.select-design-template-modal .modal-content ul, .select-template-modal .modal-content ul{
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.select-design-template-modal .modal-content ul li, .select-template-modal .modal-content ul li {
  width: calc(25% - 15px);
  display: block;
  margin-bottom: 0 !important;
}

.select-design-template-modal .modal-content .item .image, .select-template-modal .modal-content .item .image {
  border-radius: 8px;
  position: relative;
}

.select-design-template-modal .modal-content .item img, .select-template-modal .modal-content .item img {
  width: 100%;
  height: 195px;
  border-radius: 8px;
}

.select-design-template-modal .modal-content .item .image .preview-btn, .select-template-modal .modal-content .item .image .preview-btn {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #0000001a;
  width: 220px;
  height: 200px;
  border-radius: 8px;
  display: none;
  top: 0px;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  align-items: center;
}

.select-design-template-modal .modal-content .preview-btn .Polaris-Button, .select-template-modal .modal-content .preview-btn .Polaris-Button {
  width: 86px;
}

.select-design-template-modal .modal-content .selected, .select-template-modal .modal-content .selected {
  width: 66;
  height: 28;
  padding: 6px 8px;
  border-top-left-radius: 2px;
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 8px;
  background: #2c6ecb;
  color: white;
  position: absolute;
  top: 0;
  right: 0;
}

.select-design-template-modal .coming-soon, .select-template-modal .coming-soon {
  margin-left: 0 !important;
}

.select-design-template-modal .modal-content .item-selected .image, .select-template-modal .modal-content .item-selected .image {
  border: 2px solid #2c6ecb;
  width: 220px;
  height: 200px;
}

.select-design-template-modal .modal-content .item .image:hover .preview-btn, .select-template-modal .modal-content .item .image:hover .preview-btn {
  display: flex;
}

.select-design-template-modal .modal-content .item, .select-template-modal .modal-content .item {
  display: block;
}

.select-design-template-modal .modal-content .item .details, .select-template-modal .modal-content .item .details {
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  margin-left: unset;
}

.select-design-template-modal .modal-content .item .title, .select-template-modal .modal-content .item .title {
  font-weight: 500;
  overflow-wrap: break-word;
}

.modal-content ul {
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 0;
}

.modal-content ul li {
  display: inline-flex;
  align-items: center;
  width: 100%;
}

.modal-content ul li:not(:last-child) {
  margin-bottom: 14px;
}

.modal-content .item {
  width: 100%;
  display: inline-flex;
  align-items: center;
  width: 100%;
}

.modal-content .item .details {
  margin-left: 12px;
  width: 100%;
  cursor: pointer;
}

.modal-content .item .details .description,
.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .description,
.BC-Page__ShopifyIntegration .management-template .list .item .details .description {
  color: #6d7175;
  font-size: 12px;
}

.BC-Page__ShopifyIntegration .management-template .list .item .details .description {
  display: flex;
  align-items: center;
  gap: 4px;
}

.BC-Page__ShopifyIntegration .management-template .list .item .details .description .Polaris-Icon {
  width: 16px;
  height: 16px;
}

.BC-Page__ShopifyIntegration
  .management-template
  .list
  .item
  .details
  .description
  .Polaris-Icon
  .Polaris-Icon__Svg {
  fill: #8c9196;
}

.modal-content .Polaris-Link {
  display: inline-flex;
}

.modal-content .Polaris-Link .Polaris-Icon {
  padding-left: 3px;
}

.modal-content .Polaris-Banner__Ribbon,
.customize-template-modal .Polaris-Banner__Ribbon {
  display: none;
}

.modal-content .Polaris-Banner--statusWarning,
.customize-template-modal .Polaris-Banner--statusWarning {
  padding: 8px 16px;
  margin-bottom: 18px;
}

.modal-content .Polaris-Banner--statusWarning .Polaris-Banner__Content,
.customize-template-modal .Polaris-Banner--statusWarning .Polaris-Banner__Content {
  padding: 0;
}

.modal-content .explore {
  margin-bottom: 18px;
}

.modal-content .coming-soon {
  margin: 16px 0 0 32px;
  color: #6d7175;
}

/* New template instance for theme */

.Polaris-Card__Section {
  padding-top: 18px;
}

.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance {
}

.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .instance,
.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .instance {
  width: 100%;
  display: inline-flex;
  align-items: center;
  margin-bottom: 82px;
}

.BC-Page__ShopifyIntegration
  .onboarding-integration-layout
  .confirm-select-instance
  .instance.page-update {
  border-bottom: unset !important;
  margin-bottom: 0 !important;
}

.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .instance.page-update {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e1e3e5;
}

.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .instance .details {
  flex-grow: 1;
  padding-left: 16px;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .confirm-select-instance
  .instance.page-update
  .details {
  width: 100%;
  padding-left: 16px;
}

.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .details {
  width: 100%;
  padding-left: 16px;
}

.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .action {
  display: inline-flex;
}

.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .action-page-update {
  display: inline-flex;
  flex-shrink: 0;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .confirm-select-instance
  .action-page-update
  .btn-upgrade
  .Polaris-Button--disabled {
  background-color: rgb(243, 242, 242) !important;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .confirm-select-instance
  .action-page-update
  .btn-upgrade
  .Polaris-Button {
  border-radius: 4px;
  background: var(--decorative-surface-one, #ffc96b);
  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset, 0px 1px 0px 0px rgba(0, 0, 0, 0.08);
  padding: 8px !important;
  width: 100%;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .confirm-select-instance
  .instance.page-update
  .details
  .description,
.BC-Page__ShopifyIntegration__Manage .management-template .list .description {
  display: flex;
  align-items: center;
  gap: 6px;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .confirm-select-instance
  .instance.page-update
  .details
  .description.description--new,
.BC-Page__ShopifyIntegration__Manage .management-template .list .description.description--new {
  color: #202223 !important;
  font-weight: 500;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .confirm-select-instance
  .instance.page-update
  .details
  .description
  .spot,
.BC-Page__ShopifyIntegration__Manage
  .management-template
  .list
  .description.description--new
  .spot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #2c6ecb;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .confirm-select-instance
  .instance.page-update
  .details
  .description
  .chev
  .Polaris-Icon,
.BC-Page__ShopifyIntegration__Manage
  .management-template
  .list
  .description.description--new
  .chev
  .Polaris-Icon {
  margin: 0;
  width: 14px;
  height: 14px;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .confirm-select-instance
  .instance.page-update
  .details
  .description
  .chev
  .Polaris-Spinner
  svg,
.BC-Page__ShopifyIntegration__Manage
  .management-template
  .list
  .description.description--new
  .chev
  .Polaris-Spinner
  svg {
  width: 1rem;
  height: 1rem;
  position: relative;
  top: 1px;
  fill: #202223;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .confirm-select-instance
  .instance.page-update
  .details
  .description
  .chev
  .Polaris-Icon__Svg,
.BC-Page__ShopifyIntegration__Manage
  .management-template
  .list
  .description
  .chev
  .Polaris-Icon__Svg {
  fill: #5c5f62;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .confirm-select-instance
  .instance.page-update
  .details
  .description.description--new
  .chev
  .Polaris-Icon__Svg,
.BC-Page__ShopifyIntegration__Manage
  .management-template
  .list
  .description.description--new
  .chev
  .Polaris-Icon__Svg {
  fill: #1a1c1d;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .confirm-select-instance
  .instance.page-update
  .details
  div:last-child
  .Polaris-Button--plain,
.BC-Page__ShopifyIntegration__Manage
  .management-template
  .list
  .item
  .details
  div:last-child
  .Polaris-Button--plain {
  padding: 2px 8px;
  min-height: unset;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .confirm-select-instance
  .instance.page-update
  .details
  div:last-child
  .Polaris-Button--plain:hover,
.BC-Page__ShopifyIntegration__Manage
  .management-template
  .list
  .item
  .details
  div:last-child
  .Polaris-Button--plain:hover {
  text-decoration: none;
  background-color: #f6f6f7;
}

.BC-Page__ShopifyIntegration__Manage .management-template .list .updated-template-message {
  background: #dafbf3;
  padding: 2px 6px;
  color: #008060;
  display: flex;
  align-items: center;
  gap: 4px;
  max-width: max-content;
  border-radius: 4px;
  margin: 4px 0;
  font-size: 12px;
}

.BC-Page__ShopifyIntegration__Manage
  .management-template
  .list
  .updated-template-message
  .Polaris-Icon {
  margin: 0;
  width: 8px;
  height: 8px;
  position: relative;
  top: 1px;
}

.BC-Page__ShopifyIntegration__Manage
  .management-template
  .list
  .updated-template-message
  .Polaris-Icon__Svg {
  fill: #008060;
}

.BC-Page__ShopifyIntegration__Manage
  .management-template
  .list
  .updated-template-message.updated-template-message--live {
  background: #f0f9ff;
  color: #026aa2;
}

.BC-Page__ShopifyIntegration__Manage
  .management-template
  .list
  .updated-template-message.updated-template-message--live
  .Polaris-Icon__Svg {
  fill: #2c6ecb;
}

.update-version-wrapper {
  display: flex;
  align-items: baseline;
  gap: 16px;
  padding: 20px;
  max-width: 532px;
}

.update-version-wrapper .spot {
  display: block;
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #2c6ecb;
  position: relative;
  top: -1px;
}

.update-version-wrapper .update-version-content__title {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.update-version-wrapper .update-version-content__current {
  margin-bottom: 16px;
}

.update-version-wrapper .update-version-content__desc {
  margin-bottom: 12px;
}

.update-version-wrapper .update-version-content__action {
  margin-top: 16px;
}

.update-version-wrapper .update-version-content__action .Polaris-ButtonGroup__Item {
  margin-left: 8px;
  margin-top: 4px;
}

.update-version-wrapper
  .update-version-content__action
  .Polaris-ButtonGroup__Item:first-child
  .Polaris-Button__Text {
  font-weight: 500;
}

.update-version-wrapper
  .update-version-content__action
  .Polaris-ButtonGroup__Item:last-child
  .Polaris-Button__Text {
  color: #202223;
}

.update-version-wrapper .warning-conflict {
  border: 1px solid #98c6cd;
  background: #ebf9fc;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.update-version-wrapper .warning-conflict .Polaris-Link {
  color: #202223;
  white-space: nowrap;
}

.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .title,
.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .title {
  margin-bottom: 16px;
  color: #6d7175;
}

.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .title {
  margin-bottom: 16px;
}

.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .details .info-title,
.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .details .info-title {
  font-weight: 600;
  margin-bottom: 4px;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .confirm-select-instance
  .details
  .title
  .Polaris-Badge--statusInfo,
.select-template-modal .modal-content .title .Polaris-Badge--statusInfo,
.BC-Page__ShopifyIntegration
  .management-template
  .list
  .item
  .details
  .title
  .Polaris-Badge--statusInfo,
.BC-Page__ShopifyIntegration
  .confirm-select-instance
  .instance
  .info-title
  .Polaris-Badge--statusInfo {
  background-color: #e0f0ff;
  color: #00527c;
  font-weight: 500;
}

.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .description {
  /* display: inline-flex; */
  font-size: 12px;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .confirm-select-instance
  .action
  .Polaris-ButtonGroup__Item,
.BC-Page__ShopifyIntegration .integration-layout .footer .Polaris-ButtonGroup__Item,
.BC-Page__ShopifyIntegration
  .integration-layout
  .confirm-select-instance
  .action-page-update
  .Polaris-ButtonGroup__Item {
  margin-left: 12px;
}

.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .footer {
  border-top: 1px solid #e1e3e5;
  padding-top: 20px;
  text-align: right;
}

/* Setup widgets */
.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .title .Polaris-Link {
  display: inline-flex;
  align-items: center;
}

.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .title .Polaris-Link .Polaris-Icon {
  padding-left: 3px;
}

.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .title--with-link {
  margin-bottom: 4px;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .setup-widgets
  .title--with-link
  .Polaris-Link
  .Polaris-Icon {
  margin: 0;
  width: 16px;
  height: 16px;
  padding-left: 0;
  margin-left: 1px;
  position: relative;
  top: 0.5px;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .setup-widgets
  .title--with-link
  .Polaris-Link
  .Polaris-Icon
  .Polaris-Icon__Svg {
  fill: #2c6ecb;
}

.BC-Page__ShopifyIntegration .integration-layout .footer .Polaris-ButtonGroup {
  display: inline-flex;
}

.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .onboarding-features {
  display: flex;
  gap: 20px;
  justify-content: space-around;
}

.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .onboarding-features .list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: unset;
}

.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .onboarding-features .feature-item {
  border-radius: 8px;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  border: 1px solid #e1e3e5 !important;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .setup-widgets
  .onboarding-features
  .list
  .feature-item
  .content {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .onboarding-features .disabled {
  background: #fafbfb;
  border: unset !important;
}

.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .onboarding-features .selected {
  border: 1px solid #008060 !important;
  background: #f1f8f5;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .onboarding-features
  .selected
  .Polaris-Checkbox__Icon {
  background-color: #008060;
  border-radius: 4px;
}

.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .onboarding-features .disabled > p {
  color: #6d7175;
}

.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .onboarding-features img {
  width: 323px;
  border-radius: 12px;
}

.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .features {
  border: 1px solid #e1e3e5;
  border-radius: 8px;
}

.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .setup-guide {
  padding-top: 24px;
  margin-top: 24px;
  border-top: 1px solid #e1e3e5;
}

.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .setup-guide .setup-guide__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .setup-widgets
  .setup-guide
  .setup-guide__item
  .Polaris-Link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 21px 16px;
  color: #202223;
  text-decoration: none;
  background-color: #fafbfb;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .setup-widgets
  .setup-guide
  .setup-guide__item
  .Polaris-Link
  p {
  font-weight: 600 !important;
}

.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .features .feature-item {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12.5px 16px;
  gap: 8px;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .setup-widgets
  .features
  .feature-item:not(:last-child) {
  border-bottom: 1px solid #e1e3e5;
}

/* .BC-Page__ShopifyIntegration .integration-layout .setup-widgets .features .feature-item>div {
  width: 100%;
} */

.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .features .Polaris-Button {
  padding: 8px;
  height: 30px;
  min-height: unset;
  min-width: 78px;
}

.BC-Page__ShopifyIntegration
  .integration-layout
  .setup-widgets
  .features
  .feature-item
  span
  .Polaris-Button {
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: unset;
  min-height: unset;
}

.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .features .feature-action {
  display: flex;
  align-items: center;
  column-gap: 8px;
}

.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .footer {
  padding-top: 20px;
  text-align: right;
}

/* Enable Boost snippets */
.BC-Page__ShopifyIntegration .boost-snippet {
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
}

.BC-Page__ShopifyIntegration .boost-snippet .left-col {
  width: 420px;
  margin-top: 2px;
  margin-right: 26px;
}

.BC-Page__ShopifyIntegration .boost-snippet .left-col.left-col--center {
  display: flex;
  align-items: center;
}

.BC-Page__ShopifyIntegration .boost-snippet .enable-snippet {
  margin: 12px 0;
  padding: 16px;
  border: 1px solid #d0d0d0;
  border-radius: 8px;
  display: inline-flex;
  width: 420px;
  background-color: #fafbfb;
}

.BC-Page__ShopifyIntegration .boost-snippet .enable-snippet .details {
  padding-left: 10px;
  width: 100%;
}

.BC-Page__ShopifyIntegration .boost-snippet .enable-snippet .info-title {
  font-weight: 600;
  padding-bottom: 3px;
  margin-top: -1px;
}

.BC-Page__ShopifyIntegration .boost-snippet .enable-snippet .description {
  color: #6d7175;
}

.BC-Page__ShopifyIntegration .boost-snippet .enable-snippet .btn-enable {
  margin-top: 7px;
}

.BC-Page__ShopifyIntegration .boost-snippet .right-col {
  padding: 17px 18px;
  width: 50%;
}

.BC-Page__ShopifyIntegration .boost-snippet .right-col img {
  width: 100%;
  height: auto;
}

.BC-Page__ShopifyIntegration .boost-snippet .manual-instruction {
  margin-top: 12px;
}

.BC-Page__ShopifyIntegration .boost-snippet .manual-instruction ul {
  padding-inline-start: 20px;
  margin-block-start: 3px;
  margin-block-end: 12px;
}

.BC-Page__ShopifyIntegration .boost-snippet .manual-instruction .Polaris-TextField__Input:disabled,
.template-changed-modal .Polaris-TextField__Input:disabled {
  -webkit-text-fill-color: #202223;
  padding-top: 9px;
  padding-bottom: 9px;
}

.BC-Page__ShopifyIntegration .boost-snippet .manual-instruction .copy .Polaris-Icon,
.template-changed-modal .copy .Polaris-Icon {
  width: 16px;
  height: 16px;
}

.BC-Page__ShopifyIntegration
  .boost-snippet
  .manual-instruction
  .copy
  button.Polaris-Button--plain.Polaris-Button--iconOnly,
.template-changed-modal .copy button.Polaris-Button--plain.Polaris-Button--iconOnly {
  margin-top: 6px;
}

.BC-Page__ShopifyIntegration .integration-layout .footer {
  text-align: right;
}

/* Template changed modal */
.template-changed-modal .content {
  margin-bottom: 8px;
}

/* Update instance widget */
.BC-Page__ShopifyIntegration
  .integration-layout
  .confirm-select-instance
  .action-page-update
  .activator
  .Polaris-Button,
.BC-Page__ShopifyIntegration .management-template .item .action-page .activator .Polaris-Button {
  padding: 8px;
}

.BC-Page__ShopifyIntegration
  .management-template
  .item
  .action-page
  .btn-customize
  .Polaris-Button {
  padding: 8px 10px;
}

.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .heading,
.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .heading,
.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .heading,
.BC-Page__ShopifyIntegration .integration-layout .features-table .heading {
  font-weight: 600;
  margin-bottom: 2px;
}

/* App embed */
.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .instance .view-settings {
  width: 145px;
  display: inline-flex;
}

.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .instance .view-settings span {
  padding-right: 3px;
}

.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .instance.page-update {
  margin-bottom: 24px;
  border: 1px solid #c9cccf;
  border-radius: 8px;
  padding: 16px;
}

.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .instance .Polaris-Link {
  display: inline-flex;
}

.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .description {
  color: #6d7175;
  font-size: 14px;
}

/* Manage template instance page */
#manage-template-theme-name {
  font-size: 14px;
  line-height: 20px;
  color: #6d7175;
  margin-left: 52px;
  margin-top: 4px;
}

.BC-Page__ShopifyIntegration .management-template {
  margin-top: 24px;
}

.BC-Page__ShopifyIntegration .management-template .list {
  margin-top: 24px;
}

.BC-Page__ShopifyIntegration .management-template .list ul {
  list-style-type: none;
  list-style-type: none;
  padding-inline-start: 0;
  margin-bottom: 0;
}

.BC-Page__ShopifyIntegration .management-template .list ul li {
  display: inline-flex;
  align-items: center;
  width: 100%;
}

.BC-Page__ShopifyIntegration
  .management-template
  .list
  ul
  li
  .Polaris-SkeletonDisplayText__DisplayText {
  width: 100%;
  max-width: 100%;
  height: 89px;
}

.BC-Page__ShopifyIntegration .management-template .list ul li:not(:last-child) {
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e1e3e5;
}

.BC-Page__ShopifyIntegration .management-template .list .item {
  width: 100%;
  display: inline-flex;
  align-items: center;
  width: 100%;
}

.BC-Page__ShopifyIntegration .management-template .list .item .thumbnail {
  width: 90px;
  height: 72px;
  border: 1px solid #e1e3e5;
  border-radius: 8px;
  background-color: #fafbfb;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.BC-Page__ShopifyIntegration .management-template .list .item .thumbnail .Polaris-Spinner svg {
  width: 18px;
  height: 18px;
  fill: #8c9196;
}

.BC-Page__ShopifyIntegration .management-template .list .item img {
  width: 90px;
  height: 72px;
  border: 1px solid #e1e3e5;
  border-radius: 8px;
}

.BC-Page__ShopifyIntegration .management-template .list .item .details {
  margin-left: 16px;
  width: 100%;
}

.BC-Page__ShopifyIntegration .management-template .list .item .details .title {
  margin-bottom: 8px;
}

.BC-Page__ShopifyIntegration .management-template .list .item .details .title > span:first-child {
  font-weight: 600;
  margin-right: 6px;
}

.BC-Page__ShopifyIntegration
  .management-template
  .list
  .item
  .details
  .title
  .Polaris-Badge--statusSuccess {
  font-size: 12px;
}

.BC-Page__ShopifyIntegration .features-table .title {
  margin-bottom: 16px;
}

.BC-Page__ShopifyIntegration .features-table .Polaris-DataTable {
  border: 1px solid #c9cccf;
  border-radius: 8px;
}

.BC-Page__ShopifyIntegration
  .features-table
  .Polaris-DataTable__Table
  tbody
  .Polaris-DataTable__TableRow:first-child
  .Polaris-DataTable__Cell:first-child {
  border-top-left-radius: 8px;
}

.BC-Page__ShopifyIntegration
  .features-table
  .Polaris-DataTable__Table
  tbody
  .Polaris-DataTable__TableRow:first-child
  .Polaris-DataTable__Cell:last-child {
  border-top-right-radius: 8px;
}

.BC-Page__ShopifyIntegration
  .features-table
  .Polaris-DataTable__Table
  tbody
  .Polaris-DataTable__TableRow:last-child
  .Polaris-DataTable__Cell:first-child {
  border-bottom-left-radius: 8px;
}

.BC-Page__ShopifyIntegration
  .features-table
  .Polaris-DataTable__Table
  tbody
  .Polaris-DataTable__TableRow:last-child
  .Polaris-DataTable__Cell:last-child {
  border-bottom-right-radius: 8px;
}

.BC-Page__ShopifyIntegration
  .features-table
  .Polaris-DataTable__Table
  tbody
  .Polaris-DataTable__Cell:last-child {
  width: 86px;
}

/* Rename template modal */
.manage-template-modal-content .Polaris-Card__Section {
  padding-top: 16px;
  padding-bottom: 16px;
}

/* Change template modal */
.change-template-modal .content,
.customize-template-modal .content {
  padding-bottom: 20px;
}

/* Customize template modal */
.customize-template-modal .Polaris-Card__Section {
  padding: 24px 20px;
}

.customize-template-modal .Polaris-Banner--statusWarning {
  padding: 8px 16px;
  margin-bottom: 10px;
}

/* Preview */
.shopify-integration-preview .visual-editor-header .theme-name {
  width: 150px;
}

.shopify-integration-preview .visual-editor-body {
  height: auto;
}

.visual-editor-body .preview-image {
  width: 100%;
}

/* Guide */
.BC-Shopify-Integration-Guide-Page .Polaris-FullscreenBar__BackAction {
  display: none;
}

.BC-Shopify-Integration-Guide-Page .BC-BackAction {
  display: flex;
  padding: 0 16px;
  border-right: 1px solid #e1e3e5 !important;
}

.BC-Shopify-Integration-Guide-Page .BC-BackAction .Polaris-Icon {
  margin: 0 !important;
}

.BC-Shopify-Integration-Guide-Page .user-guide-header {
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 1rem;
}

.BC-Shopify-Integration-Guide-Page .user-guide-header .title {
  width: 100%;
  text-align: center;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body {
  border: 1px solid #e1e3e5;
  border-radius: 8px;
  margin: 33px auto;
  background-color: #fff;
  display: flex;
  width: 100%;
  max-width: 1182px;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .menu {
  width: 231px;
  min-width: 231px;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .menu ul {
  list-style-type: none;
  padding-inline-start: 5px;
  padding-inline-end: 12px;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .menu ul li {
  padding: 8px;
  margin-top: 4px;
  margin-bottom: 4px;
  cursor: pointer;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .menu ul li .required {
  margin-left: 6px;
}

.BC-Shopify-Integration-Guide-Page
  .user-guide-body
  .menu
  ul
  li
  .required
  .Polaris-Badge--statusAttention {
  font-size: 12px;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .menu ul li.active {
  border-radius: 4px;
  background-color: #f2f7fe;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .content {
  border-left: 1px solid #e1e3e5;
  padding: 24px;
  flex-grow: 1;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .content .heading {
  font-size: 28px;
  font-weight: 600;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .content .boost-snippet {
  display: inline-flex;
  padding-top: 32px;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .content .boost-snippet .manual-instruction ul,
.BC-Shopify-Integration-Guide-Page
  .user-guide-body
  .content
  .instruction
  .step
  .manual-instruction
  ul {
  margin-block-start: 3px;
  padding-inline-start: 27px;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .content .boost-snippet .left-col {
  padding-right: 32px;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step .enable-snippet,
.BC-Shopify-Integration-Guide-Page .user-guide-body .content .boost-snippet .left-col .btn-enable {
  padding: 16px 0;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .content .warning {
  padding-top: 32px;
  padding-bottom: 32px;
}

.BC-Shopify-Integration-Guide-Page
  .user-guide-body
  .content
  .warning
  .Polaris-Banner--statusWarning {
  padding: 16px;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step {
  background-color: #fafbfb;
  border-radius: 8px;
  padding: 20px;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step:not(:last-child) {
  margin-bottom: 24px;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step .left-col {
  margin-right: 40px;
  width: 323px;
  min-width: 323px;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step .info {
  width: 863px;
}

.BC-Shopify-Integration-Guide-Page
  .user-guide-body
  .content
  .instruction
  .step
  .info
  .Polaris-Link--monochrome {
  color: #2c6ecb;
}

.BC-Shopify-Integration-Guide-Page
  .user-guide-body
  .content
  .instruction
  .step
  .custom-style
  .Polaris-Icon {
  width: 16px;
  height: 16px;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step .asset-file {
  font-family: 'monaco';
  color: #d72c0d;
  font-size: 12px;
}

.BC-Shopify-Integration-Guide-Page
  .user-guide-body
  .content
  .instruction
  .step
  .btnGroup
  .Polaris-ButtonGroup__Item:first-child {
  margin-left: 0.5rem;
}

.BC-Shopify-Integration-Guide-Page
  .user-guide-body
  .content
  .instruction
  .step
  .btnGroup
  .Polaris-ButtonGroup__Item {
  margin-left: 12px;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step .asset-list {
  display: inline-flex;
  border: 1px solid #e1e3e5;
  border-radius: 4px;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step .asset-list .page {
  width: 50%;
}

.BC-Shopify-Integration-Guide-Page
  .user-guide-body
  .content
  .instruction
  .step
  .asset-list
  .heading {
  padding: 16px;
  font-weight: 500;
  font-size: 14px;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step .asset-list .row {
  padding: 8px 16px;
  border-top: 1px solid #e1e3e5;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step .right-col {
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .menu .menu-item {
  padding: 8px;
  max-height: 36px;
  position: relative;
  cursor: pointer;
  min-width: 193px;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .menu .menu-item:hover {
  background: #f2f7fe;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .menu .menu-item.active {
  border-radius: 4px;
  background: #f2f7fe;
}

.BC-Shopify-Integration-Guide-Page .user-guide-body .menu .menu-item.active::before {
  content: '';
  width: 3px;
  height: 36px;
  border-radius: 0px 4px 4px 0px;
  background: var(--interactive);
  position: absolute;
  left: -8px;
  top: 0;
}

.BC-Page__ShopifyIntegration .Polaris-Banner--statusWarning {
  margin-bottom: 16px;
}

.Polaris-ActionList__Section .Polaris-ActionList__Title {
  color: rgba(171, 171, 181, 1);
}

@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.template-export-otp-info .template-export-otp-info__label {
  font-weight: 600;
  margin-bottom: 8px;
}

.template-export-otp-info .template-export-otp-info__content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.template-export-otp-info .template-export-otp-info__otp {
  font-weight: 600;
  font-size: 28px;
  letter-spacing: 0.25em;
}

.template-export-otp-info .template-export-otp-info__content {
  padding: 12px 20px;
  border: 1px solid #D0D5DD;
  border-radius: 8px;
}
  
.template-export-otp-info .template-export-otp-info__content .Polaris-Button {
  border-color: #007F5F;
  color: #007F5F;
}

.template-export-otp-info .template-export-otp-info__content .Polaris-Icon__Svg {
  fill: #007F5F;
}
  
.template-export-otp-info .template-export-otp-info__expire {
  border: 1px solid #98C6CD;
  background: #EBF9FC;
  padding: 16px;
  display: flex;
  align-items: baseline;
  margin-top: 16px;
  border-radius: 4px;
}

.template-import .template-import__desc {
  margin-bottom: 16px;
}

.template-import .template-import__label {
  font-weight: 600;
  margin-bottom: 8px;
}

.template-import .template-import__input {
  border: 2px solid #C9CCCF;
  border-radius: 8px;
  width: 64px !important;
  height: 64px;
  font-size: 28px;
  font-weight: 600;
  outline-color: #008060;
}

.template-import .template-import__otp {
  gap: 16px;
}

.template-import .template-import__otp input::-webkit-outer-spin-button,
.template-import .template-import__otp input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.template-import .template-import__otp input[type=number] {
  -moz-appearance: textfield;
}

.template-import .Polaris-Link,
.template-export-otp .Polaris-Link,
.template-export-otp-info .Polaris-Link {
  text-decoration: underline !important;
}

.template-import__error-list {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.template-import .template-import__expire {
  border: 1px solid #98C6CD;
  background: #EBF9FC;
  padding: 16px;
  display: flex;
  align-items: center;
  margin-top: 16px;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/styles/shopify-integration.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;;EAKE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;;;;EAKE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;;;;;EAKE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;;;EAME,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;;;EAME,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;;EAME,eAAe;AACjB;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;EAME,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;EAChD,iDAAiD;EACjD,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,YAAY;EACZ,iBAAiB;EACjB,+FAA+F;AACjG;;AAEA;;;EAGE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;;;EAIE,WAAW;EACX,eAAe;AACjB;;AAEA;;;;;EAKE,UAAU;EACV,cAAc;EACd,oBAAoB;AACtB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gGAAgG;AAClG;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;;;;;EAKE,2BAA2B;AAC7B;;AAEA;;;;EAIE,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;;;EAGE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;EAQE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,oCAAoC;;AAEpC;EACE,iBAAiB;AACnB;;AAEA;AACA;;AAEA;;EAEE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;EAIE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;;EAKE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;;;;;EAME,+CAA+C;AACjD;;AAEA;;;;;;EAME,kBAAkB;EAClB,kDAAkD;EAClD,0FAA0F;EAC1F,uBAAuB;EACvB,WAAW;AACb;;AAEA;;;;;;;EAOE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;;;;;EAOE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;EAYE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;EAcE,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;;;;;;;;;EAgBE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,aAAa;AACf;;AAEA;;;;;;;;;;;;;;EAcE,aAAa;AACf;;AAEA;;;;;;;;;;;;;;EAcE,aAAa;AACf;;AAEA;;;;;;;;;;;;;;EAcE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;EAcE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;;;;;EAKE,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;;EAIE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;EAmBE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;;;;;;;;;;EAWE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;EAME,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;;;;EAOE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;;;;;;EAOE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;;;;;EAKE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;EACpB,QAAQ;AACV;;AAEA;;;;;EAKE,gCAAgC;AAClC;;AAEA;;GAEG;;AAEH;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;;;;EAOE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;EAEE,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;EAME,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;;;;;;;EAOE,YAAY;AACd;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;;;;EAIE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;;;EAME,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;;;;EAME,2BAA2B;AAC7B;;AAEA;;;;;;EAME,4BAA4B;AAC9B;;AAEA;;;;;;EAME,8BAA8B;AAChC;;AAEA;;;;;;EAME,+BAA+B;AACjC;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;;EAEE,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,UAAU;AACV;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;;;;;;;EAQE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;;;;;;;EAOE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;;;EAOE,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;;;;EAOE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;AACA;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,MAAM;AACR;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".BC-Page__ShopifyIntegration.BC-Page.BC-Page__ShopifyIntegration__Manage .BC-Page__Title--Help {\n  padding-left: 2px;\n}\n\n.BC-Page__ShopifyIntegration .main-layout .Polaris-Card__Header {\n  background-color: #fff;\n  border: 0;\n  padding-bottom: 0;\n}\n\n.BC-Page__ShopifyIntegration .main-layout .cardTitle {\n  align-items: center;\n  justify-content: space-between;\n}\n\n.BC-Page__ShopifyIntegration .main-layout .cardTitle .Polaris-Button__Icon {\n  width: 20px;\n  height: 20px;\n}\n\n.BC-Page__ShopifyIntegration .main-layout .empty-block {\n  border: 1px solid #e1e3e5;\n  background-color: #fafbfb;\n  padding: 24px 0;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.BC-Page__ShopifyIntegration .main-layout .manage-template-block .template-item {\n  display: flex;\n  border: 1px solid #e1e3e5;\n  border-radius: 4px;\n}\n\n.BC-Page__ShopifyIntegration .main-layout .manage-template-block .template-item__info {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  gap: 6px;\n  padding: 16px;\n}\n\n.BC-Page__ShopifyIntegration .main-layout .helper-block {\n  padding: 12px 16px;\n  background-color: #fff;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.BC-Page__ShopifyIntegration .main-layout .helper-block .Polaris-Button {\n  padding: 12px 26px;\n}\n\n.BC-Page__ShopifyIntegration .main-layout .helper-block .Polaris-Button {\n  background-color: #fafbfb;\n}\n\n.BC-Page__ShopifyIntegration .main-layout .helper-block .Polaris-Button:hover {\n  background-color: #f6f6f7;\n}\n\n.BC-Page__ShopifyIntegration .main-layout .helper-block .Polaris-Button__Text {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.BC-Page__ShopifyIntegration .main-layout .helper-block .Polaris-Button__Text .Polaris-Icon {\n  margin: 0;\n  width: 16px;\n  height: 16px;\n}\n\n.BC-Page__ShopifyIntegration\n  .main-layout\n  .helper-block\n  .Polaris-Button\n  .Polaris-Button__Content\n  > .Polaris-Button__Icon {\n  width: 14px;\n  height: 14px;\n}\n\n.BC-Page__ShopifyIntegration .main-layout .BC-Page__ShopifyIntegration__Pagination {\n  margin-top: 20px;\n  display: flex;\n  justify-content: center;\n}\n\n.BC-Page__ShopifyIntegration\n  .main-layout\n  .BC-Page__ShopifyIntegration__Pagination\n  .Polaris-ButtonGroup__Item {\n  margin-left: 12px;\n}\n\n.BC-Page__ShopifyIntegration\n  .main-layout\n  .BC-Page__ShopifyIntegration__Pagination\n  .Polaris-ButtonGroup__Item:first-child\n  .Polaris-Button {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.BC-Page__ShopifyIntegration\n  .main-layout\n  .BC-Page__ShopifyIntegration__Pagination\n  .Polaris-ButtonGroup__Item:last-child\n  .Polaris-Button {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.BC-Page__ShopifyIntegration .main-layout .Polaris-DataTable {\n  border: 1px solid rgba(225, 227, 229, 1);\n  border-radius: 8px;\n}\n\n.BC-Page__ShopifyIntegration .main-layout .Polaris-DataTable__Table thead .Polaris-DataTable__Cell {\n  padding: 12px 16px;\n  font-weight: 600;\n}\n\n.BC-Page__ShopifyIntegration\n  .main-layout\n  .Polaris-DataTable__Table\n  thead\n  .Polaris-DataTable__Cell:nth-child(2) {\n  width: 200px;\n}\n\n.BC-Page__ShopifyIntegration\n  .main-layout\n  .Polaris-DataTable__Table\n  thead\n  .Polaris-DataTable__Cell:last-child {\n  width: 113px;\n  text-align: center;\n}\n\n.BC-Page__ShopifyIntegration\n  .main-layout\n  .Polaris-DataTable__Table\n  tbody\n  .Polaris-DataTable__Cell:last-child\n  .data-cell-inner {\n  justify-content: center;\n}\n\n.BC-Page__ShopifyIntegration .main-layout .Polaris-DataTable__Table tbody .Polaris-DataTable__Cell {\n  padding: 0;\n}\n\n.BC-Page__ShopifyIntegration\n  .main-layout\n  .Polaris-DataTable__Table\n  tbody\n  .Polaris-DataTable__Cell\n  .data-cell-inner {\n  padding: 12px 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.BC-Page__ShopifyIntegration\n  .main-layout\n  .Polaris-DataTable__Table\n  tbody\n  .Polaris-DataTable__Cell\n  .data-cell-inner.data-cell-inner--default {\n  cursor: default;\n}\n\n.BC-Page__ShopifyIntegration\n  .main-layout\n  .Polaris-DataTable__Table\n  tbody\n  .Polaris-DataTable__Cell:last-child\n  .Polaris-Button {\n  min-height: 30px;\n  min-width: 81px;\n  padding: 5px 8px;\n}\n\n.BC-Page__ShopifyIntegration\n  .main-layout\n  .Polaris-DataTable__Table\n  tbody\n  .Polaris-DataTable__Cell:last-child\n  .Polaris-Button\n  .Polaris-Button__Icon {\n  width: 16px;\n  height: 16px;\n}\n\n.BC-Page__ShopifyIntegration\n  .main-layout\n  .Polaris-DataTable__Table\n  tbody\n  .Polaris-DataTable__Cell\n  .Polaris-SkeletonDisplayText__DisplayText {\n  width: 100%;\n  max-width: 100%;\n}\n\n.BC-Page__ShopifyIntegration .main-layout .select-theme-refresh {\n  height: 20px;\n  transition: all 0.4s;\n}\n\n.BC-Page__ShopifyIntegration .main-layout .select-theme-refresh.refreshing {\n  -webkit-animation: spin 2s linear infinite;\n  -moz-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n\n.btn-actions-warning .Polaris-ButtonGroup {\n  justify-content: flex-end;\n}\n\n.btn-actions-warning .btn-remove .Polaris-Button {\n  background-color: #bb8802;\n  border: 0;\n  color: #fff;\n}\n\n.btn-actions-warning .btn-remove .Polaris-Button:hover {\n  background-color: #8f6901;\n}\n\n.BC-Page__ShopifyIntegration .BC-Page__Title--Help {\n  margin-bottom: 24px;\n}\n\n.BC-Page__ShopifyIntegration .Polaris-Card__Header {\n  border-top-left-radius: var(--p-border-radius-2);\n  border-top-right-radius: var(--p-border-radius-2);\n  background-color: #fafbfb;\n}\n\n.BC-Page__ShopifyIntegration .select-theme {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.BC-Page__ShopifyIntegration .select-theme > div {\n  width: inherit;\n}\n\n/* Calculate filter: https://codepen.io/sosuke/pen/Pjoqqp */\n.BC-Page__ShopifyIntegration .BC-Shopify-Integration_Select-Theme-Form .select-theme-refresh {\n  height: 20px;\n  margin-left: 10px;\n  filter: invert(42%) sepia(13%) saturate(4337%) hue-rotate(184deg) brightness(90%) contrast(95%);\n}\n\n.BC-Page__ShopifyIntegration\n  .BC-Shopify-Integration_Select-Theme-Form\n  .select-theme-refresh.refreshing {\n  animation: rotation 2s linear infinite;\n}\n\n.BC-Page__ShopifyIntegration .BC-Shopify-Integration_Select-Theme-Form button {\n  margin-top: 16px;\n}\n\n.BC-Page__ShopifyIntegration .BC-Shopify-Integration_Select-Theme-Form .btnNext {\n  text-align: right;\n}\n\n#ssr-selected-theme-item {\n  margin-left: 5px;\n}\n\n#ssr-selected-theme-item.live .Polaris-Badge {\n  background-color: #e0f0ff;\n  color: #00527c;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.BC-Page__ShopifyIntegration .warning-none-features {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #EC4A0A;\n  background-color: #FFF6ED;\n  padding: 2px 6px;\n  margin-top: 4px;\n  border-radius: 4px;\n}\n\n.BC-Page__ShopifyIntegration .warning-none-features .Polaris-Icon {\n  width: 14px;\n  height: 14px;\n  position: relative;\n  top: 1px;\n}\n\n.BC-Page__ShopifyIntegration .warning-none-features .Polaris-Icon__Svg {\n  fill: #EC4A0A;\n}\n\n.upgraded-to-turbo .Polaris-Badge {\n  background-color: #ebf9fc;\n  color: #2c6ecb;\n  border-radius: 10px;\n}\n\n.BC-Select-Integration__option:has(.unpublished) .unpublished {\n  display: none;\n}\n\n.BC-Page__ShopifyIntegration .theme-setup-heading .Polaris-Badge {\n  margin-left: 5px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  font-size: 12px;\n  background-color: #c9cccf;\n  border-radius: 10px;\n}\n\n.BC-Page__ShopifyIntegration .theme-setup-heading .Polaris-SkeletonDisplayText__DisplayText {\n  width: 100%;\n  max-width: 100%;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .Polaris-Layout\n  .Polaris-SkeletonDisplayText__DisplayText {\n  width: 100%;\n  max-width: 100%;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .Polaris-Layout\n  .onboarding-loading\n  .Polaris-SkeletonDisplayText__DisplayText {\n  width: 20%;\n  max-width: 20%;\n  display: inline-flex;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .Polaris-Layout\n  .loading-content\n  .Polaris-SkeletonDisplayText__DisplayText {\n  height: 244px;\n}\n\n.BC-Page__ShopifyIntegration .theme-setup-heading .Polaris-Badge--statusInfo {\n  background-color: #e0f0ff;\n  color: #00527c;\n  font-weight: 500;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout {\n  margin-top: 24px;\n}\n\n/* Progress bar */\n.BC-Page__ShopifyIntegration .integration-layout .progress-bar {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .progress-bar .step-content {\n  display: inline-flex;\n  color: #6d7175;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .progress-bar .number {\n  width: 32px;\n  height: 32px;\n  border: solid 1px #e1e3e5;\n  border-radius: 50%;\n  padding-top: 4px;\n  padding-left: 11px;\n  font-weight: 700;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .progress-bar .Polaris-Icon {\n  margin: 0;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .progress-bar .Polaris-Icon .Polaris-Icon__Svg {\n  fill: #fff;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .progress-bar .label {\n  padding: 6px 0 0 8px;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .progress-bar .active,\n.BC-Page__ShopifyIntegration .integration-layout .progress-bar .activating {\n  color: #202223;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .progress-bar .active > div.number {\n  border-color: #008060;\n  background-color: #008060;\n  color: #fff;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .progress-bar .activating > div.number {\n  border-color: #008060;\n  color: #008060;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .progress-bar .separator.active {\n  filter: invert(60%) sepia(19%) saturate(2378%) hue-rotate(120deg) brightness(96%) contrast(101%);\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .progress-bar .separator {\n  margin: 0 16px 0 16px;\n}\n\n/* Empty content */\n.BC-Page__ShopifyIntegration .integration-layout .empty-content {\n  background-color: #fafbfb;\n  border-radius: 8px;\n  border: 1px solid #e1e3e5;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .empty-content\n  .Polaris-EmptyState--withinContentContainer {\n  padding-bottom: var(--p-space-5);\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .empty-content img {\n  width: 48px;\n  height: 48px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .empty-content .Polaris-DisplayText {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n  margin-top: 10px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .empty-content .Polaris-EmptyState__Content {\n  font-size: 14px;\n  margin-top: 5px;\n  padding-bottom: 0;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .copy\n  .Polaris-Button--plain.Polaris-Button--iconOnly\n  svg {\n  fill: var(--p-icon-subdued);\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .copy\n  .Polaris-Button--plain.Polaris-Button--iconOnly:hover\n  svg {\n  fill: var(--p-icon-hovered);\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .copy\n  button.Polaris-Button--plain.Polaris-Button--iconOnly {\n  margin: 3px 0 0 2px;\n  padding: 0;\n  min-width: auto;\n  min-height: auto;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .copy .Polaris-Icon {\n  width: 12px;\n  height: 12px;\n}\n\n/* Select template modal */\n.select-template-modal .Polaris-Modal-Section {\n  padding: 0;\n}\n\n.select-template-modal .modal-content ul {\n  list-style-type: none;\n}\n\n.select-template-modal .Polaris-Card__Section {\n  padding-top: 20px;\n  padding-bottom: 18px;\n}\n\n.select-template-modal .total-instance, .select-design-template-modal .total-instance {\n  padding: 2px 6px;\n  border: 1px solid #e4e5e7;\n  border-radius: 50%;\n  background-color: #e4e5e7;\n  margin-right: 4px;\n}\n\n.select-template-modal .Polaris-Tabs__Wrapper .Polaris-Tabs {\n  width: 40%;\n}\n\n.select-template-modal\n  .Polaris-Tabs__Wrapper\n  .Polaris-Tabs\n  .Polaris-Tabs__TabContainer:not(:last-child) {\n  width: 49%;\n}\n\n.select-template-modal.select-template-modal--limit .Polaris-Banner {\n  margin: 24px 20px 10px;\n}\n\n.select-template-modal.select-template-modal--limit .Polaris-Banner__Ribbon {\n  display: none;\n}\n\n.select-template-modal.select-template-modal--limit .select-template-modal--limit__guide {\n  margin: 0 20px 10px;\n}\n\n.select-design-template-modal .modal-content ul, .select-template-modal .modal-content ul{\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n.select-design-template-modal .modal-content ul li, .select-template-modal .modal-content ul li {\n  width: calc(25% - 15px);\n  display: block;\n  margin-bottom: 0 !important;\n}\n\n.select-design-template-modal .modal-content .item .image, .select-template-modal .modal-content .item .image {\n  border-radius: 8px;\n  position: relative;\n}\n\n.select-design-template-modal .modal-content .item img, .select-template-modal .modal-content .item img {\n  width: 100%;\n  height: 195px;\n  border-radius: 8px;\n}\n\n.select-design-template-modal .modal-content .item .image .preview-btn, .select-template-modal .modal-content .item .image .preview-btn {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: #0000001a;\n  width: 220px;\n  height: 200px;\n  border-radius: 8px;\n  display: none;\n  top: 0px;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n  align-items: center;\n}\n\n.select-design-template-modal .modal-content .preview-btn .Polaris-Button, .select-template-modal .modal-content .preview-btn .Polaris-Button {\n  width: 86px;\n}\n\n.select-design-template-modal .modal-content .selected, .select-template-modal .modal-content .selected {\n  width: 66;\n  height: 28;\n  padding: 6px 8px;\n  border-top-left-radius: 2px;\n  border-bottom-right-radius: 2px;\n  border-bottom-left-radius: 8px;\n  background: #2c6ecb;\n  color: white;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.select-design-template-modal .coming-soon, .select-template-modal .coming-soon {\n  margin-left: 0 !important;\n}\n\n.select-design-template-modal .modal-content .item-selected .image, .select-template-modal .modal-content .item-selected .image {\n  border: 2px solid #2c6ecb;\n  width: 220px;\n  height: 200px;\n}\n\n.select-design-template-modal .modal-content .item .image:hover .preview-btn, .select-template-modal .modal-content .item .image:hover .preview-btn {\n  display: flex;\n}\n\n.select-design-template-modal .modal-content .item, .select-template-modal .modal-content .item {\n  display: block;\n}\n\n.select-design-template-modal .modal-content .item .details, .select-template-modal .modal-content .item .details {\n  display: flex;\n  flex-direction: column;\n  margin-top: 12px;\n  margin-left: unset;\n}\n\n.select-design-template-modal .modal-content .item .title, .select-template-modal .modal-content .item .title {\n  font-weight: 500;\n  overflow-wrap: break-word;\n}\n\n.modal-content ul {\n  margin-block-start: 0;\n  margin-block-end: 0;\n  padding-inline-start: 0;\n}\n\n.modal-content ul li {\n  display: inline-flex;\n  align-items: center;\n  width: 100%;\n}\n\n.modal-content ul li:not(:last-child) {\n  margin-bottom: 14px;\n}\n\n.modal-content .item {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  width: 100%;\n}\n\n.modal-content .item .details {\n  margin-left: 12px;\n  width: 100%;\n  cursor: pointer;\n}\n\n.modal-content .item .details .description,\n.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .description,\n.BC-Page__ShopifyIntegration .management-template .list .item .details .description {\n  color: #6d7175;\n  font-size: 12px;\n}\n\n.BC-Page__ShopifyIntegration .management-template .list .item .details .description {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC-Page__ShopifyIntegration .management-template .list .item .details .description .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n.BC-Page__ShopifyIntegration\n  .management-template\n  .list\n  .item\n  .details\n  .description\n  .Polaris-Icon\n  .Polaris-Icon__Svg {\n  fill: #8c9196;\n}\n\n.modal-content .Polaris-Link {\n  display: inline-flex;\n}\n\n.modal-content .Polaris-Link .Polaris-Icon {\n  padding-left: 3px;\n}\n\n.modal-content .Polaris-Banner__Ribbon,\n.customize-template-modal .Polaris-Banner__Ribbon {\n  display: none;\n}\n\n.modal-content .Polaris-Banner--statusWarning,\n.customize-template-modal .Polaris-Banner--statusWarning {\n  padding: 8px 16px;\n  margin-bottom: 18px;\n}\n\n.modal-content .Polaris-Banner--statusWarning .Polaris-Banner__Content,\n.customize-template-modal .Polaris-Banner--statusWarning .Polaris-Banner__Content {\n  padding: 0;\n}\n\n.modal-content .explore {\n  margin-bottom: 18px;\n}\n\n.modal-content .coming-soon {\n  margin: 16px 0 0 32px;\n  color: #6d7175;\n}\n\n/* New template instance for theme */\n\n.Polaris-Card__Section {\n  padding-top: 18px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance {\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .instance,\n.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .instance {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  margin-bottom: 82px;\n}\n\n.BC-Page__ShopifyIntegration\n  .onboarding-integration-layout\n  .confirm-select-instance\n  .instance.page-update {\n  border-bottom: unset !important;\n  margin-bottom: 0 !important;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .instance.page-update {\n  margin-bottom: 24px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .instance .details {\n  flex-grow: 1;\n  padding-left: 16px;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .confirm-select-instance\n  .instance.page-update\n  .details {\n  width: 100%;\n  padding-left: 16px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .details {\n  width: 100%;\n  padding-left: 16px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .action {\n  display: inline-flex;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .action-page-update {\n  display: inline-flex;\n  flex-shrink: 0;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .confirm-select-instance\n  .action-page-update\n  .btn-upgrade\n  .Polaris-Button--disabled {\n  background-color: rgb(243, 242, 242) !important;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .confirm-select-instance\n  .action-page-update\n  .btn-upgrade\n  .Polaris-Button {\n  border-radius: 4px;\n  background: var(--decorative-surface-one, #ffc96b);\n  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset, 0px 1px 0px 0px rgba(0, 0, 0, 0.08);\n  padding: 8px !important;\n  width: 100%;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .confirm-select-instance\n  .instance.page-update\n  .details\n  .description,\n.BC-Page__ShopifyIntegration__Manage .management-template .list .description {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .confirm-select-instance\n  .instance.page-update\n  .details\n  .description.description--new,\n.BC-Page__ShopifyIntegration__Manage .management-template .list .description.description--new {\n  color: #202223 !important;\n  font-weight: 500;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .confirm-select-instance\n  .instance.page-update\n  .details\n  .description\n  .spot,\n.BC-Page__ShopifyIntegration__Manage\n  .management-template\n  .list\n  .description.description--new\n  .spot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #2c6ecb;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .confirm-select-instance\n  .instance.page-update\n  .details\n  .description\n  .chev\n  .Polaris-Icon,\n.BC-Page__ShopifyIntegration__Manage\n  .management-template\n  .list\n  .description.description--new\n  .chev\n  .Polaris-Icon {\n  margin: 0;\n  width: 14px;\n  height: 14px;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .confirm-select-instance\n  .instance.page-update\n  .details\n  .description\n  .chev\n  .Polaris-Spinner\n  svg,\n.BC-Page__ShopifyIntegration__Manage\n  .management-template\n  .list\n  .description.description--new\n  .chev\n  .Polaris-Spinner\n  svg {\n  width: 1rem;\n  height: 1rem;\n  position: relative;\n  top: 1px;\n  fill: #202223;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .confirm-select-instance\n  .instance.page-update\n  .details\n  .description\n  .chev\n  .Polaris-Icon__Svg,\n.BC-Page__ShopifyIntegration__Manage\n  .management-template\n  .list\n  .description\n  .chev\n  .Polaris-Icon__Svg {\n  fill: #5c5f62;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .confirm-select-instance\n  .instance.page-update\n  .details\n  .description.description--new\n  .chev\n  .Polaris-Icon__Svg,\n.BC-Page__ShopifyIntegration__Manage\n  .management-template\n  .list\n  .description.description--new\n  .chev\n  .Polaris-Icon__Svg {\n  fill: #1a1c1d;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .confirm-select-instance\n  .instance.page-update\n  .details\n  div:last-child\n  .Polaris-Button--plain,\n.BC-Page__ShopifyIntegration__Manage\n  .management-template\n  .list\n  .item\n  .details\n  div:last-child\n  .Polaris-Button--plain {\n  padding: 2px 8px;\n  min-height: unset;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .confirm-select-instance\n  .instance.page-update\n  .details\n  div:last-child\n  .Polaris-Button--plain:hover,\n.BC-Page__ShopifyIntegration__Manage\n  .management-template\n  .list\n  .item\n  .details\n  div:last-child\n  .Polaris-Button--plain:hover {\n  text-decoration: none;\n  background-color: #f6f6f7;\n}\n\n.BC-Page__ShopifyIntegration__Manage .management-template .list .updated-template-message {\n  background: #dafbf3;\n  padding: 2px 6px;\n  color: #008060;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  max-width: max-content;\n  border-radius: 4px;\n  margin: 4px 0;\n  font-size: 12px;\n}\n\n.BC-Page__ShopifyIntegration__Manage\n  .management-template\n  .list\n  .updated-template-message\n  .Polaris-Icon {\n  margin: 0;\n  width: 8px;\n  height: 8px;\n  position: relative;\n  top: 1px;\n}\n\n.BC-Page__ShopifyIntegration__Manage\n  .management-template\n  .list\n  .updated-template-message\n  .Polaris-Icon__Svg {\n  fill: #008060;\n}\n\n.BC-Page__ShopifyIntegration__Manage\n  .management-template\n  .list\n  .updated-template-message.updated-template-message--live {\n  background: #f0f9ff;\n  color: #026aa2;\n}\n\n.BC-Page__ShopifyIntegration__Manage\n  .management-template\n  .list\n  .updated-template-message.updated-template-message--live\n  .Polaris-Icon__Svg {\n  fill: #2c6ecb;\n}\n\n.update-version-wrapper {\n  display: flex;\n  align-items: baseline;\n  gap: 16px;\n  padding: 20px;\n  max-width: 532px;\n}\n\n.update-version-wrapper .spot {\n  display: block;\n  flex-shrink: 0;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #2c6ecb;\n  position: relative;\n  top: -1px;\n}\n\n.update-version-wrapper .update-version-content__title {\n  font-weight: 600;\n  font-size: 16px;\n  margin-bottom: 4px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.update-version-wrapper .update-version-content__current {\n  margin-bottom: 16px;\n}\n\n.update-version-wrapper .update-version-content__desc {\n  margin-bottom: 12px;\n}\n\n.update-version-wrapper .update-version-content__action {\n  margin-top: 16px;\n}\n\n.update-version-wrapper .update-version-content__action .Polaris-ButtonGroup__Item {\n  margin-left: 8px;\n  margin-top: 4px;\n}\n\n.update-version-wrapper\n  .update-version-content__action\n  .Polaris-ButtonGroup__Item:first-child\n  .Polaris-Button__Text {\n  font-weight: 500;\n}\n\n.update-version-wrapper\n  .update-version-content__action\n  .Polaris-ButtonGroup__Item:last-child\n  .Polaris-Button__Text {\n  color: #202223;\n}\n\n.update-version-wrapper .warning-conflict {\n  border: 1px solid #98c6cd;\n  background: #ebf9fc;\n  padding: 12px 16px;\n  border-radius: 4px;\n  margin-bottom: 16px;\n}\n\n.update-version-wrapper .warning-conflict .Polaris-Link {\n  color: #202223;\n  white-space: nowrap;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .title,\n.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .title {\n  margin-bottom: 16px;\n  color: #6d7175;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .title {\n  margin-bottom: 16px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .details .info-title,\n.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .details .info-title {\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .confirm-select-instance\n  .details\n  .title\n  .Polaris-Badge--statusInfo,\n.select-template-modal .modal-content .title .Polaris-Badge--statusInfo,\n.BC-Page__ShopifyIntegration\n  .management-template\n  .list\n  .item\n  .details\n  .title\n  .Polaris-Badge--statusInfo,\n.BC-Page__ShopifyIntegration\n  .confirm-select-instance\n  .instance\n  .info-title\n  .Polaris-Badge--statusInfo {\n  background-color: #e0f0ff;\n  color: #00527c;\n  font-weight: 500;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .description {\n  /* display: inline-flex; */\n  font-size: 12px;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .confirm-select-instance\n  .action\n  .Polaris-ButtonGroup__Item,\n.BC-Page__ShopifyIntegration .integration-layout .footer .Polaris-ButtonGroup__Item,\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .confirm-select-instance\n  .action-page-update\n  .Polaris-ButtonGroup__Item {\n  margin-left: 12px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .footer {\n  border-top: 1px solid #e1e3e5;\n  padding-top: 20px;\n  text-align: right;\n}\n\n/* Setup widgets */\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .title .Polaris-Link {\n  display: inline-flex;\n  align-items: center;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .title .Polaris-Link .Polaris-Icon {\n  padding-left: 3px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .title--with-link {\n  margin-bottom: 4px;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .setup-widgets\n  .title--with-link\n  .Polaris-Link\n  .Polaris-Icon {\n  margin: 0;\n  width: 16px;\n  height: 16px;\n  padding-left: 0;\n  margin-left: 1px;\n  position: relative;\n  top: 0.5px;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .setup-widgets\n  .title--with-link\n  .Polaris-Link\n  .Polaris-Icon\n  .Polaris-Icon__Svg {\n  fill: #2c6ecb;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .footer .Polaris-ButtonGroup {\n  display: inline-flex;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .onboarding-features {\n  display: flex;\n  gap: 20px;\n  justify-content: space-around;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .onboarding-features .list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  border: unset;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .onboarding-features .feature-item {\n  border-radius: 8px;\n  padding: 20px 16px;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #e1e3e5 !important;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .setup-widgets\n  .onboarding-features\n  .list\n  .feature-item\n  .content {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .onboarding-features .disabled {\n  background: #fafbfb;\n  border: unset !important;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .onboarding-features .selected {\n  border: 1px solid #008060 !important;\n  background: #f1f8f5;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .onboarding-features\n  .selected\n  .Polaris-Checkbox__Icon {\n  background-color: #008060;\n  border-radius: 4px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .onboarding-features .disabled > p {\n  color: #6d7175;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .onboarding-features img {\n  width: 323px;\n  border-radius: 12px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .features {\n  border: 1px solid #e1e3e5;\n  border-radius: 8px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .setup-guide {\n  padding-top: 24px;\n  margin-top: 24px;\n  border-top: 1px solid #e1e3e5;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .setup-guide .setup-guide__wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .setup-widgets\n  .setup-guide\n  .setup-guide__item\n  .Polaris-Link {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 21px 16px;\n  color: #202223;\n  text-decoration: none;\n  background-color: #fafbfb;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .setup-widgets\n  .setup-guide\n  .setup-guide__item\n  .Polaris-Link\n  p {\n  font-weight: 600 !important;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .features .feature-item {\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 12.5px 16px;\n  gap: 8px;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .setup-widgets\n  .features\n  .feature-item:not(:last-child) {\n  border-bottom: 1px solid #e1e3e5;\n}\n\n/* .BC-Page__ShopifyIntegration .integration-layout .setup-widgets .features .feature-item>div {\n  width: 100%;\n} */\n\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .features .Polaris-Button {\n  padding: 8px;\n  height: 30px;\n  min-height: unset;\n  min-width: 78px;\n}\n\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .setup-widgets\n  .features\n  .feature-item\n  span\n  .Polaris-Button {\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: unset;\n  min-height: unset;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .features .feature-action {\n  display: flex;\n  align-items: center;\n  column-gap: 8px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .footer {\n  padding-top: 20px;\n  text-align: right;\n}\n\n/* Enable Boost snippets */\n.BC-Page__ShopifyIntegration .boost-snippet {\n  display: inline-flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.BC-Page__ShopifyIntegration .boost-snippet .left-col {\n  width: 420px;\n  margin-top: 2px;\n  margin-right: 26px;\n}\n\n.BC-Page__ShopifyIntegration .boost-snippet .left-col.left-col--center {\n  display: flex;\n  align-items: center;\n}\n\n.BC-Page__ShopifyIntegration .boost-snippet .enable-snippet {\n  margin: 12px 0;\n  padding: 16px;\n  border: 1px solid #d0d0d0;\n  border-radius: 8px;\n  display: inline-flex;\n  width: 420px;\n  background-color: #fafbfb;\n}\n\n.BC-Page__ShopifyIntegration .boost-snippet .enable-snippet .details {\n  padding-left: 10px;\n  width: 100%;\n}\n\n.BC-Page__ShopifyIntegration .boost-snippet .enable-snippet .info-title {\n  font-weight: 600;\n  padding-bottom: 3px;\n  margin-top: -1px;\n}\n\n.BC-Page__ShopifyIntegration .boost-snippet .enable-snippet .description {\n  color: #6d7175;\n}\n\n.BC-Page__ShopifyIntegration .boost-snippet .enable-snippet .btn-enable {\n  margin-top: 7px;\n}\n\n.BC-Page__ShopifyIntegration .boost-snippet .right-col {\n  padding: 17px 18px;\n  width: 50%;\n}\n\n.BC-Page__ShopifyIntegration .boost-snippet .right-col img {\n  width: 100%;\n  height: auto;\n}\n\n.BC-Page__ShopifyIntegration .boost-snippet .manual-instruction {\n  margin-top: 12px;\n}\n\n.BC-Page__ShopifyIntegration .boost-snippet .manual-instruction ul {\n  padding-inline-start: 20px;\n  margin-block-start: 3px;\n  margin-block-end: 12px;\n}\n\n.BC-Page__ShopifyIntegration .boost-snippet .manual-instruction .Polaris-TextField__Input:disabled,\n.template-changed-modal .Polaris-TextField__Input:disabled {\n  -webkit-text-fill-color: #202223;\n  padding-top: 9px;\n  padding-bottom: 9px;\n}\n\n.BC-Page__ShopifyIntegration .boost-snippet .manual-instruction .copy .Polaris-Icon,\n.template-changed-modal .copy .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n.BC-Page__ShopifyIntegration\n  .boost-snippet\n  .manual-instruction\n  .copy\n  button.Polaris-Button--plain.Polaris-Button--iconOnly,\n.template-changed-modal .copy button.Polaris-Button--plain.Polaris-Button--iconOnly {\n  margin-top: 6px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .footer {\n  text-align: right;\n}\n\n/* Template changed modal */\n.template-changed-modal .content {\n  margin-bottom: 8px;\n}\n\n/* Update instance widget */\n.BC-Page__ShopifyIntegration\n  .integration-layout\n  .confirm-select-instance\n  .action-page-update\n  .activator\n  .Polaris-Button,\n.BC-Page__ShopifyIntegration .management-template .item .action-page .activator .Polaris-Button {\n  padding: 8px;\n}\n\n.BC-Page__ShopifyIntegration\n  .management-template\n  .item\n  .action-page\n  .btn-customize\n  .Polaris-Button {\n  padding: 8px 10px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .confirm-select-instance .heading,\n.BC-Page__ShopifyIntegration .integration-layout .setup-widgets .heading,\n.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .heading,\n.BC-Page__ShopifyIntegration .integration-layout .features-table .heading {\n  font-weight: 600;\n  margin-bottom: 2px;\n}\n\n/* App embed */\n.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .instance .view-settings {\n  width: 145px;\n  display: inline-flex;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .instance .view-settings span {\n  padding-right: 3px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .instance.page-update {\n  margin-bottom: 24px;\n  border: 1px solid #c9cccf;\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .instance .Polaris-Link {\n  display: inline-flex;\n}\n\n.BC-Page__ShopifyIntegration .integration-layout .app-embed-instance .description {\n  color: #6d7175;\n  font-size: 14px;\n}\n\n/* Manage template instance page */\n#manage-template-theme-name {\n  font-size: 14px;\n  line-height: 20px;\n  color: #6d7175;\n  margin-left: 52px;\n  margin-top: 4px;\n}\n\n.BC-Page__ShopifyIntegration .management-template {\n  margin-top: 24px;\n}\n\n.BC-Page__ShopifyIntegration .management-template .list {\n  margin-top: 24px;\n}\n\n.BC-Page__ShopifyIntegration .management-template .list ul {\n  list-style-type: none;\n  list-style-type: none;\n  padding-inline-start: 0;\n  margin-bottom: 0;\n}\n\n.BC-Page__ShopifyIntegration .management-template .list ul li {\n  display: inline-flex;\n  align-items: center;\n  width: 100%;\n}\n\n.BC-Page__ShopifyIntegration\n  .management-template\n  .list\n  ul\n  li\n  .Polaris-SkeletonDisplayText__DisplayText {\n  width: 100%;\n  max-width: 100%;\n  height: 89px;\n}\n\n.BC-Page__ShopifyIntegration .management-template .list ul li:not(:last-child) {\n  margin-bottom: 14px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e1e3e5;\n}\n\n.BC-Page__ShopifyIntegration .management-template .list .item {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  width: 100%;\n}\n\n.BC-Page__ShopifyIntegration .management-template .list .item .thumbnail {\n  width: 90px;\n  height: 72px;\n  border: 1px solid #e1e3e5;\n  border-radius: 8px;\n  background-color: #fafbfb;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.BC-Page__ShopifyIntegration .management-template .list .item .thumbnail .Polaris-Spinner svg {\n  width: 18px;\n  height: 18px;\n  fill: #8c9196;\n}\n\n.BC-Page__ShopifyIntegration .management-template .list .item img {\n  width: 90px;\n  height: 72px;\n  border: 1px solid #e1e3e5;\n  border-radius: 8px;\n}\n\n.BC-Page__ShopifyIntegration .management-template .list .item .details {\n  margin-left: 16px;\n  width: 100%;\n}\n\n.BC-Page__ShopifyIntegration .management-template .list .item .details .title {\n  margin-bottom: 8px;\n}\n\n.BC-Page__ShopifyIntegration .management-template .list .item .details .title > span:first-child {\n  font-weight: 600;\n  margin-right: 6px;\n}\n\n.BC-Page__ShopifyIntegration\n  .management-template\n  .list\n  .item\n  .details\n  .title\n  .Polaris-Badge--statusSuccess {\n  font-size: 12px;\n}\n\n.BC-Page__ShopifyIntegration .features-table .title {\n  margin-bottom: 16px;\n}\n\n.BC-Page__ShopifyIntegration .features-table .Polaris-DataTable {\n  border: 1px solid #c9cccf;\n  border-radius: 8px;\n}\n\n.BC-Page__ShopifyIntegration\n  .features-table\n  .Polaris-DataTable__Table\n  tbody\n  .Polaris-DataTable__TableRow:first-child\n  .Polaris-DataTable__Cell:first-child {\n  border-top-left-radius: 8px;\n}\n\n.BC-Page__ShopifyIntegration\n  .features-table\n  .Polaris-DataTable__Table\n  tbody\n  .Polaris-DataTable__TableRow:first-child\n  .Polaris-DataTable__Cell:last-child {\n  border-top-right-radius: 8px;\n}\n\n.BC-Page__ShopifyIntegration\n  .features-table\n  .Polaris-DataTable__Table\n  tbody\n  .Polaris-DataTable__TableRow:last-child\n  .Polaris-DataTable__Cell:first-child {\n  border-bottom-left-radius: 8px;\n}\n\n.BC-Page__ShopifyIntegration\n  .features-table\n  .Polaris-DataTable__Table\n  tbody\n  .Polaris-DataTable__TableRow:last-child\n  .Polaris-DataTable__Cell:last-child {\n  border-bottom-right-radius: 8px;\n}\n\n.BC-Page__ShopifyIntegration\n  .features-table\n  .Polaris-DataTable__Table\n  tbody\n  .Polaris-DataTable__Cell:last-child {\n  width: 86px;\n}\n\n/* Rename template modal */\n.manage-template-modal-content .Polaris-Card__Section {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n\n/* Change template modal */\n.change-template-modal .content,\n.customize-template-modal .content {\n  padding-bottom: 20px;\n}\n\n/* Customize template modal */\n.customize-template-modal .Polaris-Card__Section {\n  padding: 24px 20px;\n}\n\n.customize-template-modal .Polaris-Banner--statusWarning {\n  padding: 8px 16px;\n  margin-bottom: 10px;\n}\n\n/* Preview */\n.shopify-integration-preview .visual-editor-header .theme-name {\n  width: 150px;\n}\n\n.shopify-integration-preview .visual-editor-body {\n  height: auto;\n}\n\n.visual-editor-body .preview-image {\n  width: 100%;\n}\n\n/* Guide */\n.BC-Shopify-Integration-Guide-Page .Polaris-FullscreenBar__BackAction {\n  display: none;\n}\n\n.BC-Shopify-Integration-Guide-Page .BC-BackAction {\n  display: flex;\n  padding: 0 16px;\n  border-right: 1px solid #e1e3e5 !important;\n}\n\n.BC-Shopify-Integration-Guide-Page .BC-BackAction .Polaris-Icon {\n  margin: 0 !important;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-header {\n  display: flex;\n  flex-grow: 1;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  padding: 0 1rem;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-header .title {\n  width: 100%;\n  text-align: center;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body {\n  border: 1px solid #e1e3e5;\n  border-radius: 8px;\n  margin: 33px auto;\n  background-color: #fff;\n  display: flex;\n  width: 100%;\n  max-width: 1182px;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .menu {\n  width: 231px;\n  min-width: 231px;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .menu ul {\n  list-style-type: none;\n  padding-inline-start: 5px;\n  padding-inline-end: 12px;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .menu ul li {\n  padding: 8px;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  cursor: pointer;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .menu ul li .required {\n  margin-left: 6px;\n}\n\n.BC-Shopify-Integration-Guide-Page\n  .user-guide-body\n  .menu\n  ul\n  li\n  .required\n  .Polaris-Badge--statusAttention {\n  font-size: 12px;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .menu ul li.active {\n  border-radius: 4px;\n  background-color: #f2f7fe;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .content {\n  border-left: 1px solid #e1e3e5;\n  padding: 24px;\n  flex-grow: 1;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .content .heading {\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .content .boost-snippet {\n  display: inline-flex;\n  padding-top: 32px;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .content .boost-snippet .manual-instruction ul,\n.BC-Shopify-Integration-Guide-Page\n  .user-guide-body\n  .content\n  .instruction\n  .step\n  .manual-instruction\n  ul {\n  margin-block-start: 3px;\n  padding-inline-start: 27px;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .content .boost-snippet .left-col {\n  padding-right: 32px;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step .enable-snippet,\n.BC-Shopify-Integration-Guide-Page .user-guide-body .content .boost-snippet .left-col .btn-enable {\n  padding: 16px 0;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .content .warning {\n  padding-top: 32px;\n  padding-bottom: 32px;\n}\n\n.BC-Shopify-Integration-Guide-Page\n  .user-guide-body\n  .content\n  .warning\n  .Polaris-Banner--statusWarning {\n  padding: 16px;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step {\n  background-color: #fafbfb;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step:not(:last-child) {\n  margin-bottom: 24px;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step .left-col {\n  margin-right: 40px;\n  width: 323px;\n  min-width: 323px;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step .info {\n  width: 863px;\n}\n\n.BC-Shopify-Integration-Guide-Page\n  .user-guide-body\n  .content\n  .instruction\n  .step\n  .info\n  .Polaris-Link--monochrome {\n  color: #2c6ecb;\n}\n\n.BC-Shopify-Integration-Guide-Page\n  .user-guide-body\n  .content\n  .instruction\n  .step\n  .custom-style\n  .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step .asset-file {\n  font-family: 'monaco';\n  color: #d72c0d;\n  font-size: 12px;\n}\n\n.BC-Shopify-Integration-Guide-Page\n  .user-guide-body\n  .content\n  .instruction\n  .step\n  .btnGroup\n  .Polaris-ButtonGroup__Item:first-child {\n  margin-left: 0.5rem;\n}\n\n.BC-Shopify-Integration-Guide-Page\n  .user-guide-body\n  .content\n  .instruction\n  .step\n  .btnGroup\n  .Polaris-ButtonGroup__Item {\n  margin-left: 12px;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step .asset-list {\n  display: inline-flex;\n  border: 1px solid #e1e3e5;\n  border-radius: 4px;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step .asset-list .page {\n  width: 50%;\n}\n\n.BC-Shopify-Integration-Guide-Page\n  .user-guide-body\n  .content\n  .instruction\n  .step\n  .asset-list\n  .heading {\n  padding: 16px;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step .asset-list .row {\n  padding: 8px 16px;\n  border-top: 1px solid #e1e3e5;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .content .instruction .step .right-col {\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .menu .menu-item {\n  padding: 8px;\n  max-height: 36px;\n  position: relative;\n  cursor: pointer;\n  min-width: 193px;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .menu .menu-item:hover {\n  background: #f2f7fe;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .menu .menu-item.active {\n  border-radius: 4px;\n  background: #f2f7fe;\n}\n\n.BC-Shopify-Integration-Guide-Page .user-guide-body .menu .menu-item.active::before {\n  content: '';\n  width: 3px;\n  height: 36px;\n  border-radius: 0px 4px 4px 0px;\n  background: var(--interactive);\n  position: absolute;\n  left: -8px;\n  top: 0;\n}\n\n.BC-Page__ShopifyIntegration .Polaris-Banner--statusWarning {\n  margin-bottom: 16px;\n}\n\n.Polaris-ActionList__Section .Polaris-ActionList__Title {\n  color: rgba(171, 171, 181, 1);\n}\n\n@-moz-keyframes spin {\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n.template-export-otp-info .template-export-otp-info__label {\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.template-export-otp-info .template-export-otp-info__content {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.template-export-otp-info .template-export-otp-info__otp {\n  font-weight: 600;\n  font-size: 28px;\n  letter-spacing: 0.25em;\n}\n\n.template-export-otp-info .template-export-otp-info__content {\n  padding: 12px 20px;\n  border: 1px solid #D0D5DD;\n  border-radius: 8px;\n}\n  \n.template-export-otp-info .template-export-otp-info__content .Polaris-Button {\n  border-color: #007F5F;\n  color: #007F5F;\n}\n\n.template-export-otp-info .template-export-otp-info__content .Polaris-Icon__Svg {\n  fill: #007F5F;\n}\n  \n.template-export-otp-info .template-export-otp-info__expire {\n  border: 1px solid #98C6CD;\n  background: #EBF9FC;\n  padding: 16px;\n  display: flex;\n  align-items: baseline;\n  margin-top: 16px;\n  border-radius: 4px;\n}\n\n.template-import .template-import__desc {\n  margin-bottom: 16px;\n}\n\n.template-import .template-import__label {\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.template-import .template-import__input {\n  border: 2px solid #C9CCCF;\n  border-radius: 8px;\n  width: 64px !important;\n  height: 64px;\n  font-size: 28px;\n  font-weight: 600;\n  outline-color: #008060;\n}\n\n.template-import .template-import__otp {\n  gap: 16px;\n}\n\n.template-import .template-import__otp input::-webkit-outer-spin-button,\n.template-import .template-import__otp input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\n.template-import .template-import__otp input[type=number] {\n  -moz-appearance: textfield;\n}\n\n.template-import .Polaris-Link,\n.template-export-otp .Polaris-Link,\n.template-export-otp-info .Polaris-Link {\n  text-decoration: underline !important;\n}\n\n.template-import__error-list {\n  list-style: none;\n  padding-left: 0;\n  margin: 0;\n}\n\n.template-import .template-import__expire {\n  border: 1px solid #98C6CD;\n  background: #EBF9FC;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  margin-top: 16px;\n  border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
